<template>
    <div class="helper-page">
        <span class="classification-title">安卓用户：</span>
        <template v-for="item in stepAndOptions">
            <step-component
                :key="'STEP_OPTION_AND_ITEM_KEY_'+item.title"
                :title="item.title"
                :sub-title="item.subTitle"
                :img="item.img"/>
        </template>
        <span class="classification-title">IOS用户：</span>
        <template v-for="item in stepIOSOptions">
            <step-component
                :key="'STEP_OPTION_IOS_ITEM_KEY_'+item.title"
                :title="item.title"
                :sub-title="item.subTitle"
                :img="item.img"/>
        </template>
    </div>
</template>

<script>
import StepComponent from '@/views/helper/StepComponent'
export default {
    name: 'dy',
    components: { StepComponent },
    data () {
        return {
            stepAndOptions: [
                {
                    title: '第一步',
                    subTitle: '点击抖音，进入“我”的页面点击示意图右侧图标。',
                    img: require('@/assets/dy/dy01.png')
                },
                {
                    title: '第二步',
                    subTitle: '点击“更多功能”。',
                    img: require('@/assets/dy/dy02.png')
                },
                {
                    title: '第三步',
                    subTitle: '点击“我的二维码”即可获得链接',
                    img: require('@/assets/dy/dy03.png')
                },
                {
                    title: '第四步',
                    subTitle: '点击右侧图标。',
                    img: require('@/assets/dy/dy04.png')
                }
            ],
            stepIOSOptions: [
                {
                    title: '第一步',
                    subTitle: '点击抖音，进入个人资料页点击“抖音号”右侧图标。',
                    img: require('@/assets/dy/dy05.png')
                },
                {
                    title: '第二步',
                    subTitle: '点击右侧图标。',
                    img: require('@/assets/dy/dy06.png')
                },
                {
                    title: '第三步',
                    subTitle: '点击“复制链接”即可获得链接',
                    img: require('@/assets/dy/dy07.png')
                }
            ]
        }
    }
}
</script>

<style scoped lang="less" src="./HelperPage.less">
</style>
